/**
 * @generated SignedSource<<12ac7f7045d2d41a09e6709bc301c50e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderWorkflowMenu_placeholder$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderSidePanel_placeholder">;
  readonly " $fragmentType": "PlaceholderWorkflowMenu_placeholder";
};
export type PlaceholderWorkflowMenu_placeholder$key = {
  readonly " $data"?: PlaceholderWorkflowMenu_placeholder$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaceholderWorkflowMenu_placeholder">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "plannerStartDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaceholderWorkflowMenu_placeholder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "plannerStartDate",
          "variableName": "plannerStartDate"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PlaceholderSidePanel_placeholder"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "be8444c54c664053ce5347ff5415b8c5";

export default node;
